import {
  Button,
  Form,
  Icon,
  Input,
  notification,
  Popconfirm,
  Table,
  Tag,
  Tooltip,
} from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Show from "../../../contexts/PermissionContext/Show";
import api from "../../../services/api";
import EditDrawer from "./EditDrawer";
import "./index.css";
import { FreireContext } from "../../../utils/freireContext";
import * as texts from "../locales";
import { sorter } from "../../../utils/sorter";

class ListReportGroups extends Component {
  static contextType = FreireContext;

  state = {
    currentGroup: {},
    loadingTable: false,
    loadingSave: false,
    visibleDrawer: false,
    loadingDrawer: false,
    dateFiltrada: [],
    tablePage: 1,
  };

  getColumns = () => {
    const { freire } = this.context;

    return [
      {
        title: freire(texts.GROUP),
        dataIndex: "name",
        key: "name",
      },
      {
        title: freire(texts.EMAIL),
        dataIndex: "emails",
        key: "emails",
        width: "50%",
        render: (emails) => (
          <span>
            {emails.map((email) => (
              <Tag
                style={{ marginRight: 8, marginTop: 4, marginBottom: 4 }}
                color="purple"
                key={email}
              >
                {email}
              </Tag>
            ))}
          </span>
        ),
      },
      {
        title: freire(texts.STATIONS),
        dataIndex: "stations",
        key: "stations",
        width: "25%",
        render: (stations) => (
          <span>
            {stations.map((station) => (
              <Tag
                style={{ marginRight: 8, marginTop: 4, marginBottom: 4 }}
                color="blue"
                key={station}
              >
                {station}
              </Tag>
            ))}
          </span>
        ),
      },
      {
        title: freire(texts.ACTIONS),
        key: "acoes",
        width: 150,
        render: (group, data) => (
          <>
            <Show when={"edit-report-group"}>
              <Tooltip placement="top" title={freire(texts.SHOW_DETAILS_EDIT)}>
                <Button
                  shape="circle"
                  size="small"
                  ghost
                  type="primary"
                  style={{ marginRight: 8 }}
                  onClick={() =>
                    this.setState({
                      visibleDrawer: true,
                      currentGroup: group,
                    })
                  }
                >
                  <Icon type="edit" />
                </Button>
              </Tooltip>
            </Show>

            <Show when={"delete-report-group"}>
              <Tooltip placement="top" title={freire(texts.DELETE)}>
                <Popconfirm
                  placement="top"
                  title={freire(texts.CONFIRM_DELETE)}
                  okText={freire(texts.YES)}
                  cancelText={freire(texts.NO)}
                  onConfirm={() => this.deleteGroup(group)}
                >
                  <Button
                    style={{ marginRight: 8 }}
                    shape="circle"
                    size="small"
                    ghost
                    type="danger"
                  >
                    <Icon type="delete" />
                  </Button>
                </Popconfirm>
              </Tooltip>
            </Show>
          </>
        ),
      },
    ];
  };

  componentDidMount() {
    this.getReportGroups();
  }

  async updateGroup(data) {
    const { freire } = this.context;

    this.setState({ loadingDrawer: true }, async () => {
      try {
        await api.put(`report_group/${this.state.currentGroup._id}`, data);

        this.setState({ loadingDrawer: false, visibleDrawer: false });

        notification.success({
          message: freire(texts.ALL_RIGHT),
          description: freire(texts.GROUP_EDITED_SUCCESS),
        });

        this.getReportGroups();
      } catch (error) {
        notification.error({
          message: freire(texts.OOPS),
          description: freire(texts.ERROR_EDIT_GROUP),
        });
        this.setState({ loadingDrawer: false });
      }
    });
  }

  async deleteGroup(group) {
    const { freire } = this.context;

    this.setState({ loadingTable: true }, async () => {
      try {
        await api.delete(`report_group/${group._id}`);

        this.setState({ loadingTable: false });

        notification.success({
          message: freire(texts.ALL_RIGHT),
          description: freire(texts.GROUP_DELETED_SUCCESS),
        });

        this.getReportGroups();
      } catch (error) {
        notification.error({
          message: freire(texts.OOPS),
          description: freire(texts.ERROR_GROUP_DELETE),
        });
        this.setState({ loadingTable: false });
      }
    });
  }

  async getReportGroups(params = {}) {
    const { freire } = this.context;

    this.setState({ loadingTable: true }, async () => {
      try {
        const { data } = await api.get(`report_groups`, { params });

        this.setState({
          dateFiltrada: sorter(data),
          loadingTable: false,
        });
      } catch (error) {
        notification.error({
          message: freire(texts.OOPS),
          description: freire(texts.ERROR_GET_REPORT_GROUPS),
        });
        this.setState({ loadingTable: false });
      }
    });
  }

  filter = () => {
    this.props.form.validateFields((err, values) => {
      if (!values.name) values.name = undefined;

      if (!err) {
        this.getReportGroups(values);
      }
    });

    this.setState({ tablePage: 1 });
  };

  clearFilters = () => {
    this.props.form.resetFields();
    this.setState({ dateFiltrada: [] });
    this.getReportGroups();
  };

  goNew = () => {
    this.props.history.push("/dashboard/new_report_group");
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      visibleDrawer,
      loadingDrawer,
      currentGroup,
      loadingTable,
      dateFiltrada,
    } = this.state;
    const { freire } = this.context;

    const columns = this.getColumns();

    return (
      <div className="container">
        <Breadcrumbs
          breadcrumbs={[
            freire(texts.ADMIN),
            freire(texts.GROUPS),
            freire(texts.LISTING_REPORTS_GROUPS),
          ]}
        />
        <div className="filter">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              this.filter();
            }}
            wrapperCol={{ span: 24 }}
          >
            <Form.Item>
              <div style={{ flexDirection: "row", display: "flex" }}>
                {getFieldDecorator("name")(
                  <Input
                    onSubmit={this.filter}
                    className="firstInput"
                    placeholder={freire(texts.SEARCH_BY_GROUP_NAME)}
                  />
                )}
                <Button
                  icon="search"
                  className="buttonSearch"
                  onClick={this.filter}
                >
                  {freire(texts.SEARCH)}
                </Button>
                <Show when={"add-report-group"}>
                  <Button
                    icon="plus"
                    className="buttonNew"
                    onClick={this.goNew}
                    type="primary"
                  >
                    {freire(texts.NEW)}
                  </Button>
                </Show>
              </div>
            </Form.Item>
          </Form>

          <div className="footer">
            <Button style={{ marginRight: 10 }} onClick={this.clearFilters}>
              {freire(texts.CLEAR)}
            </Button>
            <Button onClick={this.filter} type="primary">
              {freire(texts.FILTER)}
            </Button>
          </div>
        </div>

        <Table
          style={{ backgroundColor: "white" }}
          scroll={{ x: 1300 }}
          tableLayout="auto"
          rowKey={(data) => data._id}
          loading={loadingTable}
          dataSource={dateFiltrada}
          columns={columns}
          pagination={{
            current: this.state.tablePage,
            onChange: (page) => this.setState({ tablePage: page }),
          }}
        />

        <EditDrawer
          visible={visibleDrawer}
          loading={loadingDrawer}
          onClose={() => this.setState({ visibleDrawer: false })}
          onSave={(values) => this.updateGroup(values)}
          group={currentGroup}
        />
      </div>
    );
  }
}
const PageCoupons = Form.create({ name: "filters" })(ListReportGroups);
export default withRouter(PageCoupons);
